// extracted by mini-css-extract-plugin
export default {"formContainer":"style_formContainer__JnV8x","formGroup":"style_formGroup__Fh77A","title":"style_title__IBIk+","btn":"style_btn__sqmxd"};